<pbc-sorter [config]="BerichteSorterConfig" [sorter]="berichte.sorter$ | async" (sorterChange)="berichte.sorter$.next($event)"></pbc-sorter>
